<div class="container">
    <div class="row">
        <div class="col-lg-10 offset-lg-1 col-md-12 col-sm-12 no-mt-mobile">
            <div class="row big-div-latest mb-3">
                <div class="col-md-12 col-lg-12 pb-2 mb-4">
                    <app-package-and-collection
                        [title]="'Recently Viewed'"
                        [packagesQuery]="packagesQuery"
                        [collectionsQuery]="collectionsQuery"
                        [catalogsQuery]="catalogsQuery"
                        (onLoadCatalogsClick)="updateCatalogsFetchingQuery($event)"
                        (onLoadPackagesClick)="updatePackageFetchingQuery($event)"
                        (onLoadCollectionsClick)="updateCollectionsFetchingQuery($event)"
                    >
                        <div packagesEmptyState class="text-center">
                            <p class="text-dark-gray mt-3">
                                You have not recently viewed any packages. Try the
                                <a [routerLink]="['/']">latest updates</a> page
                            </p>
                        </div>

                        <div packagesErrorState class="text-center">
                            <p class="text-dark-gray mt-3">
                                Could not load the recently updated packages. Reload the page and if the issue persists
                                please contact support.
                            </p>
                        </div>
                    </app-package-and-collection>
                </div>
            </div>
        </div>
    </div>
</div>
